var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1016 23H6.09766C5.8226 23 5.59961 22.6983 5.59961 22.3262C5.59961 21.954 5.8226 21.6523 6.09766 21.6523H22.1016C22.3766 21.6523 22.5996 21.954 22.5996 22.3262C22.5996 22.6983 22.3766 23 22.1016 23Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1523 22.9999H7.45703C7.0849 22.9999 6.7832 22.6982 6.7832 22.3261V15.7676C6.7832 15.1483 7.287 14.6445 7.90624 14.6445H9.7031C10.3223 14.6445 10.8261 15.1483 10.8261 15.7676V22.3261C10.8261 22.6982 10.5244 22.9999 10.1523 22.9999ZM8.13085 21.6523H9.4785V15.9922H8.13085V21.6523ZM9.7031 15.9922H9.70355H9.7031Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5429 22.9999H12.8477C12.4755 22.9999 12.1738 22.6982 12.1738 22.3261V13.2969C12.1738 12.6776 12.6776 12.1738 13.2969 12.1738H15.0937C15.713 12.1738 16.2168 12.6776 16.2168 13.2969V22.3261C16.2168 22.6982 15.9151 22.9999 15.5429 22.9999ZM13.5215 21.6523H14.8691V13.5215H13.5215V21.6523ZM15.0937 13.5215H15.0942H15.0937Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9336 22.9999H18.2383C17.8661 22.9999 17.5645 22.6982 17.5645 22.3261V8.80468C17.5645 8.18544 18.0682 7.68164 18.6875 7.68164H20.4844C21.1036 7.68164 21.6074 8.18544 21.6074 8.80468V22.3261C21.6074 22.6982 21.3057 22.9999 20.9336 22.9999ZM18.9121 21.6522H20.2597V9.02929H18.9121V21.6522ZM20.4844 9.02929H20.4848H20.4844Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17382 13.1738C5.80169 13.1738 5.5 12.8721 5.5 12.5C5.5 12.1279 5.80169 11.8262 6.17382 11.8262C8 11.8262 8.95025 11.6889 12.8215 9.06891C16.3829 6.65864 19.2207 3.49886 20.6074 0.399772C20.7594 0.0600753 21.158 -0.0921188 21.4976 0.0599406C21.8373 0.21191 21.9895 0.610499 21.8375 0.950195C20.3512 4.27201 17.3403 7.63798 13.5768 10.185C9.48495 12.9543 8 13.1738 6.17382 13.1738Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3246 5.46592C22.027 5.46592 21.7548 5.26737 21.6742 4.9663L20.7452 1.49922L17.2781 2.42824C16.9185 2.52464 16.5491 2.31126 16.4528 1.9518C16.3565 1.59234 16.5698 1.22286 16.9293 1.12655L21.0472 0.0231396C21.4068 -0.0732171 21.7761 0.14016 21.8725 0.499577L22.9759 4.61753C23.0722 4.97699 22.8589 5.34647 22.4994 5.44279C22.441 5.45842 22.3823 5.46592 22.3246 5.46592Z",
    fill: "#364863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownReport);
export default __webpack_public_path__ + "static/media/dropdown-report.53bc37a42f7ee81a18d9f21792ef3c3b.svg";
export { ForwardRef as ReactComponent };